/** @jsxImportSource @emotion/react */
import React from "react";
import "../../NetworkDropdown/NetworkDropdown.css";
import { ReactComponent as WalletIcon } from "../../../img/wallet.svg";
import "./ConnectWalletButton.css";
import { ConnectWalletText } from "./elements/ConnectWalletText";
import { useMediaQuery } from "usehooks-ts";
import { ConnectWalletButtonContainer } from "./elements/ConnectWalletButtonContainer";
import { Interpolation, Theme } from "@emotion/react";

export interface CustomConnectButtonProps {
  onClick: () => void;
  isInHeader: boolean;
  border?: "sharp" | "smooth";
  buttonCss?: Interpolation<Theme>;
  buttonText?: string;
  showIcon?: boolean;
}

export const ConnectWallet: React.FC<CustomConnectButtonProps> = ({
  onClick,
  isInHeader,
  border = "smooth",
  buttonCss,
  buttonText,
  showIcon = true,
}) => {
  const matchesMaxWidth432Px = useMediaQuery("(max-width: 432px)");
  return (
    <ConnectWalletButtonContainer
      onClick={onClick}
      type="button"
      border={border}
      data-testid="connect-wallet-btn"
      css={buttonCss}
    >
      {showIcon && <WalletIcon />}
      <ConnectWalletText isVisible={!(isInHeader && matchesMaxWidth432Px)} className="ms-2">
        {buttonText ?? "Connect Wallet"}
      </ConnectWalletText>
    </ConnectWalletButtonContainer>
  );
};
